import React from "react";
import { Mascot } from "../brand/Mascot";
import { Scribble, Tape, HandArrow } from "../brand/Doodles";

const THOUGHTS = [
  "I wish this happened automatically.",
  "I have an app idea, but I'm not a developer.",
  "There has to be a better way to do this.",
];
const NOTE_STYLE = [
  { rotate: -2.5, bg: "#FFFFFF", mt: 0 },
  { rotate: 1.8, bg: "#D6F3FC", mt: 28 },
  { rotate: -1.2, bg: "#FFFFFF", mt: 8 },
];

export const Problem = () => {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="relative ggm-paper"
      style={{ paddingTop: "clamp(64px, 10vh, 140px)", paddingBottom: "clamp(64px, 10vh, 140px)" }}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="max-w-4xl">
          <h2
            className="font-condensed font-bold uppercase"
            style={{ fontSize: "clamp(2rem, 4.5vw, 3.5rem)", lineHeight: 1.02, letterSpacing: "-0.02em", color: "var(--ggm-navy)" }}
            data-testid="problem-headline"
          >
            You don't need another AI tool.
          </h2>
          <p
            className="relative inline-block mt-4 font-condensed font-bold uppercase"
            style={{ fontSize: "clamp(1.25rem, 3vw, 2rem)", lineHeight: 1.15, letterSpacing: "-0.01em", color: "var(--ggm-orbit-blue)" }}
            data-testid="problem-sub"
          >
            You need AI to actually do something.
            <Scribble color="var(--ggm-orbit-blue)" className="absolute left-0 -bottom-3 w-full h-4" />
          </p>
        </div>

        <div className="mt-14 md:mt-16 grid gap-10 md:gap-8 md:grid-cols-3" data-testid="problem-thoughts">
          {THOUGHTS.map((q, i) => (
            <figure
              key={i}
              data-testid={`problem-thought-${i}`}
              className="relative p-7 pt-9"
              style={{
                background: NOTE_STYLE[i].bg,
                transform: `rotate(${NOTE_STYLE[i].rotate}deg)`,
                marginTop: NOTE_STYLE[i].mt,
                boxShadow: "0 14px 28px -16px rgba(11,30,58,0.45)",
              }}
            >
              <Tape style={{ background: "rgba(11,60,220,0.14)" }} />
              <blockquote
                className="font-condensed italic leading-snug"
                style={{ fontSize: "clamp(1.15rem, 2vw, 1.4rem)", color: "var(--ggm-navy)" }}
              >
                &ldquo;{q}&rdquo;
              </blockquote>
            </figure>
          ))}
        </div>

        <div className="mt-16 md:mt-20 grid gap-8 md:grid-cols-[1fr_auto] items-center">
          <div className="md:pl-10">
            <h3
              className="font-condensed font-bold uppercase"
              style={{ fontSize: "clamp(1.5rem, 3.5vw, 2.5rem)", lineHeight: 1.05, letterSpacing: "-0.015em", color: "var(--ggm-navy)" }}
              data-testid="problem-closer"
            >
              That's where I come in.
            </h3>
            <p className="mt-4 font-body text-base md:text-lg leading-relaxed max-w-2xl" style={{ color: "rgba(11,30,58,0.78)" }}>
              I help businesses and entrepreneurs turn problems, repetitive work, and
              big ideas into AI-powered systems that actually work.
            </p>
          </div>

          <div className="hidden md:flex items-center gap-2 relative shrink-0" data-testid="problem-mascot-frame">
            <HandArrow color="var(--ggm-orbit-blue)" className="w-24 h-12 -mr-4" style={{ transform: "rotate(160deg) scaleY(-1)" }} />
            <Mascot pose="pointing" size="lg" className="mx-auto" style={{ transform: "scaleX(-1)" }} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;
